<template>
    <div class="loading-spinner text-white" v-if="show">
        <i class="far fa-spinner-third fa-spin text-2xl"></i>
    </div>
</template>
<script>
export default {
    name: 'Loading',
    props: {
        show: {
            type: Boolean,
            default: false,
        },
    },
    data: () => ({}),
    methods: {},
};
</script>
